import { render, staticRenderFns } from "./Certificate_setting.vue?vue&type=template&id=6ad50b8a"
import script from "./Certificate_setting.vue?vue&type=script&lang=js"
export * from "./Certificate_setting.vue?vue&type=script&lang=js"
import style0 from "./Certificate_setting.vue?vue&type=style&index=0&id=6ad50b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports